export type ListActivityType = {
  LocationUploadedToList: number;
  LocationDeletedFromList: number;
  LocationCopiedToList: number;
  LocationUpdatedInList: number;
  LocationMovedFromList: number;
  ListCreated: number;
  ListUpdate: number;
  ListUpdateNew: number;
  ListDeleted: number;
  ListAnalyzing: number;
  ListShared: number;
  ListUnShared: number;
  ListUnSharedWithAll: number;
};
